import { Modal, Box, IconButton, Divider, Tabs, Tab } from '@mui/material';
import { Close } from '@mui/icons-material';
import { useState } from 'react';
import { UserInfo } from '../../hooks/useUserInfo';
import Logout from '../auth/Logout';
import { a11yProps } from '../../utils/a11y';
import TabPanel from '../TabPanel';
import UserDetails from './UserDetails';
import ApiKeyManagement from './ApiKeyManagement';

interface UserModalProps {
  open: boolean;
  onClose: () => void;
  userInfo: UserInfo | undefined;
  updateUserInfo: (oldPassword: string, newPassword: string, newNickname: string) => Promise<void>;
}

const style = {
  position: 'absolute',
  top: '10%',
  left: '50%',
//  transform: 'translate(-50%, -50%)',
  transform: 'translateX(-50%)',
  width: '80vw',
  maxWidth: '600px',
  bgcolor: 'WhiteSmoke',
  boxShadow: 24,
  p: 4,
  borderRadius: 2,
  outline: 'none',
} as const;

const closeButtonStyle = {
  position: 'absolute',
  top: '5px',
  right: '5px',
} as const;

export default function UserModal(props: UserModalProps) {
  const { open, onClose } = props;
  const [currentTabIndex, setCurrentTabIndex] = useState(0);
  const handleTabChange = (_event: React.SyntheticEvent, newIndex: number) => {
    setCurrentTabIndex(newIndex);
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={style}>
        <Tabs
          value={currentTabIndex}
          onChange={handleTabChange}
          aria-label="auth tabs"
          centered
        >
          <Tab label="User Info" {...a11yProps(0)} />
          <Tab label="API Key" {...a11yProps(1)} />
        </Tabs>
	<TabPanel value={currentTabIndex} index={0}>
	  <UserDetails {...props}/>
	</TabPanel>
	<TabPanel  value={currentTabIndex} index={1}>
	  <ApiKeyManagement {...props}/>
	</TabPanel>
	
	<Divider sx={{ my: 2 }} /> {/* This adds top and bottom margins */}

        <Logout onLogout={onClose} />

        <IconButton size="small" sx={closeButtonStyle} onClick={onClose}>
          <Close />
        </IconButton>
      </Box>
    </Modal>
  );
}
